import { decodeDataUrl, encodeDataUrl } from './data-url';
import { SignatureFormat } from '../signature-types';
export const encodePoints = points => encodeDataUrl(JSON.stringify(points), SignatureFormat.POINTS, 'text');
export const decodePoints = dataUrl => {
  const decodedDataUrl = decodeDataUrl(dataUrl);
  if (decodedDataUrl && (decodedDataUrl == null ? void 0 : decodedDataUrl.type) === SignatureFormat.POINTS) {
    try {
      const points = JSON.parse(decodedDataUrl.value);
      return points;
    } catch (e) {
      return null;
    }
  }
  return null;
};
//# sourceMappingURL=points.js.map